import { lazy, type ComponentType } from 'react'

const KEY = 'mauj:chunk-reload'

/**
 * Lazy-loads a page. If the file can't be fetched (usually because a new version was deployed
 * while the tab was open), reload once to pick up the new files instead of showing an error.
 */
export function lazyWithRetry<T extends ComponentType<object>>(load: () => Promise<{ default: T }>) {
  return lazy(async () => {
    try {
      const mod = await load()
      try { sessionStorage.removeItem(KEY) } catch { /* storage blocked */ }
      return mod
    } catch (err) {
      let reloaded = false
      try { reloaded = sessionStorage.getItem(KEY) === '1' } catch { /* storage blocked */ }
      if (!reloaded) {
        try { sessionStorage.setItem(KEY, '1') } catch { /* storage blocked */ }
        window.location.reload()
        return new Promise<{ default: T }>(() => undefined)
      }
      throw err
    }
  })
}
